/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

// @flow

import {
  CITY,
  STATE,
  STREET,
  ZIP,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';

// State is a <select> of two-letter abbreviations here, free text elsewhere.
const ABBREVIATED_STATE_REGIONS = ['US', 'CA'];

const findByType = (components, type) =>
  components.find(c => c && Array.isArray(c.types) && c.types.includes(type)) || null;

const textOf = (component, abbreviated = false) => {
  if (!component) {
    return '';
  }
  return (abbreviated ? component.shortText : component.longText) || '';
};

const addressComponentsToFieldValues = (
  components: ?Array<Object>,
  regionCode: ?string
): Object => {
  const list = Array.isArray(components) ? components : [];
  const streetNumber = textOf(findByType(list, 'street_number'));
  const route = textOf(findByType(list, 'route'));
  const abbreviatedState = ABBREVIATED_STATE_REGIONS.includes(regionCode);

  return {
    [STREET]: [streetNumber, route].filter(Boolean).join(' '),
    [CITY]:
      textOf(findByType(list, 'locality')) ||
      textOf(findByType(list, 'postal_town')) ||
      textOf(findByType(list, 'sublocality')),
    [STATE]: textOf(findByType(list, 'administrative_area_level_1'), abbreviatedState),
    [ZIP]: textOf(findByType(list, 'postal_code')),
  };
};

export default addressComponentsToFieldValues;
